const mapStatus = (status) => {
switch (status) {
     case "1":
        return "Partielle"
     case "0" : 
        return "En cours"
     case "2" :
        return "Terminée"
}
}
export default mapStatus;